import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";
import { ApiClientProvider } from "./components/ApiProvider";

export function AppAuthWrapper({ includeAuth0 }) {
  if(includeAuth0){
    return (
            <Auth0Provider
              domain={window['auth0Config'].AUTH_0_DOMAIN}
              clientId={window['auth0Config'].AUTH_0_CLIENT_ID}
              authorizationParams={{
                redirect_uri: window.location.origin,
              }}
            >
              <ApiClientProvider>
                <App />  
              </ApiClientProvider>
            </Auth0Provider>
      );
  }else{
    return (
        <ApiClientProvider>
          <App />  
        </ApiClientProvider>
     );
  }
}
